import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationSlot } from '../../../../model/reservation';

interface IProps extends StyledComponentProps {
    reservationSlot?: reservationSlot;
    notAvailable?: boolean;
    disabled?: boolean;
    duration?: number;
    minuteHeight: number;
    showReservationSlotDetail: (reservationSlot: reservationSlot) => void;
}

const getTypographyText = (props: IProps) => {
    if (props.notAvailable && props.duration) {
        return ("FUORI ORARIO")
    }
    if (props.reservationSlot) {
        return props.reservationSlot.capacity - props.reservationSlot.booked > 0 ?
            `${props.reservationSlot.capacity - props.reservationSlot.booked}/${props.reservationSlot.capacity} POSTI LIBERI` : "SLOT COMPLETO"
    }
    return "Error"
}

const getClassName = (props: IProps) => {
    const classes = props.classes;
    if (props.notAvailable && props.duration) {
        return classes.reservationNotAvailableSlotCell
    }
    if (props.reservationSlot) {
        return clsx(classes.reservationFreeSlotCell,
            {
                [classes.reservationFullSlotCell]: props.reservationSlot.booked >= props.reservationSlot.capacity,
                // eslint-disable-next-line
                ["disabled"]: props.disabled
            })
    }
    return "";
}

const ReservationSlot = (props: IProps) => {
    // const classes = props.classes;
    let className = getClassName(props);
    let text = getTypographyText(props);
    return (<Grid container
        onClick={() => { if (!props.disabled && props.reservationSlot) { props.showReservationSlotDetail(props.reservationSlot) } }}
        className={className}
        style={props.reservationSlot ? { height: `${props.reservationSlot.duration * props.minuteHeight}px` } : { height: `${props.duration * props.minuteHeight}px` }}>
        <Typography>
            {text}
        </Typography>
    </Grid>
    );

};
export default withStyles(styles as any)(ReservationSlot)